<form [formGroup]="machForm" (ngSubmit)="onSubmit()" class="py-10 w-full max-w-lg content-center">


    <div class="flex flex-wrap -mx-3 mb-6">

      <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">

        <mat-form-field class="w-full py-3 px-4 mb-3">
          <mat-label>Gamma (ɣ) &nbsp; value</mat-label>
          <input matInput formControlName="gammaVal" autocomplete="off">
          <mat-error *ngIf="machForm.invalid && machForm.touched">

            <span class="myerror">1.0 &lt; ɣ &le; 1.67</span>
          </mat-error>
        </mat-form-field>
      </div>
      
      <div class="w-full md:w-1/2 px-3">
        <mat-form-field class="w-full py-3 px-4">
          <mat-label>Mach value</mat-label>
          <input matInput formControlName="machVal" autocomplete="off">
        </mat-form-field>
      </div>
    </div>
  
    <div class="justify-center items-center">
    <!-- <div fxLayoutAlign="center center"> -->
      <section class="jontester">
        <span *ngIf="machForm.value.machVal >= 5">WARNING: HYPERSONIC</span>
      </section>
    </div>
  
    <div class="justify-center items-center" class="sbmtArea">
    <!-- <div fxLayoutAlign="center center" class="sbmtArea"> -->
      <button mat-raised-button type="submit" [disabled]="machForm.invalid" class="wideload">Calculate</button>
    </div>
  </form>
    
  <div class="justify-center" *ngIf="mBool">
  <!-- <div fxLayoutAlign="center" *ngIf="mBool">     -->
    <table>
      <tr>
        <td>
            <img src="assets/math/ppt_b.svg" alt="">
            <!-- <span class="mathitalic">P &frasl; P<sub>t</sub></span> -->
        </td>
        <td> <span class="asana2">{{ isenp_pt()  | number:'.1-5' }}</span></td>
      </tr>
      <tr>
        <td>
          <img src="assets/math/ttt_b.svg" alt="">
            <!-- <span class="mathitalic">
                T &frasl; T<sub>t</sub>
            </span> -->
        </td>
        <td>
          <span class="mymath2">{{ isenT_Tt() | number:'.1-5' }}</span>
        </td>
      </tr>
      <tr>
        <td>
          <img src="assets/math/aas2.svg" alt="">

            <!-- <span class="mathitalic">
                A &frasl; A*
            </span> -->
        </td>
        <td>
          <span class="asana2">{{ isenA_As() | number:'.1-5'}}</span>
        </td>
      </tr>
      <tr>
        <td>
          <img src="assets/math/paptas2.svg" alt="">

            <!-- <span class="mathitalic">
                pA &frasl; p<sub>t</sub> A*
            </span> -->
        </td>
        <td>
          <span class="asana2">{{ isenpA_ptAstar()  | number:'.1-5'  }}</span>
        </td>
      </tr>
      <tr>
        <td>
          <img src="assets/math/pm.svg" alt="">

            <!-- <span>Prandtl-Meyer angle (ν)</span> -->
        </td>
        <td>{{ isenpm() | number:'.1-5' }}</td>
      </tr>
      <tr>
        <td>
            <!-- <span>Mach angle (μ)</span>       -->
            <img src="assets/math/mach_ang_b.svg" alt="">
        <td>
          <span class="asana2">{{ isenmach_angle() | number:'.1-5' }}</span>      

        </td>
      </tr>
      <tr>
        <td>
            <!-- <span>CFopt</span> -->
            <img src="assets/math/cfopt_b.svg" alt="">
        </td>
        <td>
            <span class="asana2">{{isen_cfopt() | number:'.1-5' }}</span>
        </td>
      </tr>
      <tr>
        <td>
          <img src="assets/math/rrt_b.svg" alt="">
            <!-- <span>ρ/ρt</span> -->
        </td>
        <td>
          <span class="asana2">{{ isen_rhot() | number:'.1-5' }}</span>
        </td>
      </tr>
    </table>
  </div>